'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct8 from "./scala.-Product8.js";
var $p;
/** @constructor */
function $c_T8(_1, _2, _3, _4, _5, _6, _7, _8) {
  this.q5 = null;
  this.q6 = null;
  this.q7 = null;
  this.q8 = null;
  this.q9 = null;
  this.qa = null;
  this.qb = null;
  this.qc = null;
  this.q5 = _1;
  this.q6 = _2;
  this.q7 = _3;
  this.q8 = _4;
  this.q9 = _5;
  this.qa = _6;
  this.qb = _7;
  this.qc = _8;
}
export { $c_T8 as $c_T8 };
$p = $c_T8.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T8;
/** @constructor */
function $h_T8() {
}
export { $h_T8 as $h_T8 };
$h_T8.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 8;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct8.$f_s_Product8__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 1998822530, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T8) && ((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q5, x$0.q5) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q6, x$0.q6)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q7, x$0.q7)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q8, x$0.q8)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q9, x$0.q9)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qa, x$0.qa)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qb, x$0.qb)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.qc, x$0.qc))));
});
$p.o = (function() {
  return "Tuple8";
});
$p.b = (function() {
  return (((((((((((((((("(" + this.q5) + ",") + this.q6) + ",") + this.q7) + ",") + this.q8) + ",") + this.q9) + ",") + this.qa) + ",") + this.qb) + ",") + this.qc) + ")");
});
function $isArrayOf_T8(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eS)));
}
export { $isArrayOf_T8 as $isArrayOf_T8 };
var $d_T8 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T8, "scala.Tuple8", ({
  eS: 1,
  b: 1,
  c: 1,
  s1: 1,
  a: 1
}));
export { $d_T8 as $d_T8 };
